/**
 * Source types a survey submission can declare intent to auto-link to (see
 * `docs/superpowers/plans/2026-09-11-nc-temperature-survey-dialog.md`).
 *
 * Mirrors the backend `NonConformitySourceType` Prisma enum values exactly
 * (EQUIPMENT is excluded on purpose: it has no daily record to auto-link to).
 * Kept here as a plain string union — not imported from Prisma — because
 * `shared` cannot depend on the backend's generated client.
 */
export const SURVEY_NON_CONFORMITY_SOURCE_TYPES = [
  'TEMPERATURE',
  'CLEANING',
  'OIL',
  'PEST_CONTROL',
  'BLAST_CHILLING',
  'COOKING_TEMPERATURE',
  'METAL_DETECTION',
] as const;

export type SurveyNonConformitySourceType = (typeof SURVEY_NON_CONFORMITY_SOURCE_TYPES)[number];

/**
 * Intent captured at submit time: link the resulting signed PDF to the
 * non-conformity record that triggered the survey. Persisted verbatim into
 * `SurveyResponse.metadata.nonConformityLink` and consumed by
 * `SurveyPdfService` when the PDF (and its `SignedDocument`) is born.
 */
export type SurveyNonConformityLink = {
  sourceType: SurveyNonConformitySourceType;
  sourceId: string;
  /** Day of the record, `YYYY-MM-DD`. */
  recordDate: string;
};
